<div class="dropdown" [class]="'manage-job-status-wrapper '">
  <button
    [class]="'manage-job-status ' + statusClassName"
    class="btn dropdown-toggle"
    type="button"
    id="dropdownMenuButton"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false">
    {{ statusLabel }}
  </button>
  <div *ngIf="isAllowed('manage_jobs', 'edit')" class="dropdown-menu" aria-labelledby="dropdownMenuButton">
    <a class="dropdown-item" (click)="updateJobStatus('New Job')" href="javascript:;">New Job</a>
    <a class="dropdown-item" (click)="updateJobStatus('Hold')" href="javascript:;">Hold</a>
    <a class="dropdown-item" (click)="updateJobStatus('Active')" href="javascript:;">Active</a>
    <a class="dropdown-item" (click)="updateJobStatus('Inactive')" href="javascript:;">Inactive</a>
  </div>
</div>
